export default __webpack_public_path__ + "static/media/gm-sbo-girl.03b4ef61.webp";